export default class JobService {
    saveJob = (data, route) => {
        return axios.post(route, data);
    };

    updateJob = (job, data) => {
        return axios.post(`/jobs/${job}`, data);
    };

    reallocateJob = (job, data) => {
        return axios.post(`/jobs/${job}/reallocate`, data);
    };

    updateSpecialRequests = (jobId, specialRequests) => {
        return axios.patch(`/jobs/${jobId}/special-requests`, {
            special_requests: specialRequests,
        });
    };

    createFollowOn = (job) => {
        return axios.post(`/jobs/${job}/follow-on`);
    };
}
